module.exports = {"341502001":"中市街道","341502002":"东市街道","341502003":"三里桥街道","341502004":"望城街道","341502005":"清水河街道","341502100":"木厂镇","341502101":"马头镇","341502102":"东桥镇","341502103":"张店镇","341502104":"毛坦厂镇","341502105":"东河口镇","341502106":"双河镇","341502107":"施桥镇","341502108":"孙岗镇","341502109":"三十铺镇","341502110":"椿树镇","341502200":"城北乡","341502201":"翁墩乡","341502202":"淠东乡","341502203":"中店乡","341502204":"横塘岗乡","341502205":"先生店乡","341502400":"六安经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341502.json
// module id = 1042
// module chunks = 0